import { defaultLocale, localeOptions } from "Constants/defaultValues";
import { CHANGE_LOCALE } from "Constants/actionTypes";
import type { AppLocaleCode } from "../state";

function readInitialLocale(): AppLocaleCode {
  const raw = localStorage.getItem("currentLanguage");
  if (
    (raw === "en" || raw === "fr") &&
    localeOptions.some((x: { id: string }) => x.id === raw)
  ) {
    return raw;
  }
  return defaultLocale === "en" || defaultLocale === "fr"
    ? defaultLocale
    : "en";
}

const INIT_STATE: { locale: AppLocaleCode } = {
  locale: readInitialLocale()
};

type ChangeLocaleAction = { type: "CHANGE_LOCALE"; payload: AppLocaleCode };

export default function settingsReducer(
  state = INIT_STATE,
  action: ChangeLocaleAction | { type: string }
) {
  if (action.type === CHANGE_LOCALE) {
    return {
      ...state,
      locale: (action as ChangeLocaleAction).payload
    };
  }
  return { ...state };
}
